"use client";

import Link from "./router-link";
import { ArrowUpRight } from "lucide-react";
import {
  ImageComparison,
  ImageComparisonImage,
  ImageComparisonSlider,
} from "./core/image-comparison";

type Solution = {
  slug: string;
  number: string;
  title: string;
  description: string;
  image: string;
  tags: string[];
};

export function SolutionComparison({ solutions }: { solutions: Solution[] }) {
  const [leftSolution, rightSolution] = solutions;

  return (
    <div className="solution-comparison">
      <ImageComparison
        className="solution-comparison-media"
        enableHover
        springOptions={{ stiffness: 900, damping: 80, mass: 0.18 }}
      >
        <ImageComparisonImage
          className="solution-image-layer-left"
          src={leftSolution.image}
          alt={leftSolution.title}
          position="left"
        >
          <SolutionImageContent solution={leftSolution} />
        </ImageComparisonImage>
        <ImageComparisonImage
          className="solution-image-layer-right"
          src={rightSolution.image}
          alt={rightSolution.title}
          position="right"
        >
          <SolutionImageContent solution={rightSolution} />
        </ImageComparisonImage>
        <ImageComparisonSlider />
      </ImageComparison>
    </div>
  );
}

function SolutionImageContent({ solution }: { solution: Solution }) {
  return (
    <div className="solution-image-copy">
      <span className="solution-path-number">{solution.number}</span>
      <h3>{solution.title}</h3>
      <p>{solution.description}</p>
      <ul className="feature-list">
        {solution.tags.map((tag) => (
          <li key={tag}>{tag}</li>
        ))}
      </ul>
      <Link className="text-link" href={`/solutions/${solution.slug}`}>
        查看增长路径 <ArrowUpRight size={16} />
      </Link>
    </div>
  );
}
